import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import InventoryForm from '../components/InventoryForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import InventoryTransactionList from '../components/InventoryTransactionList';
import InventoryStockList from '../components/InventoryStockList';

function InventoryDashboardPage() {
	const {getInventoryStockList, getInventoryTransactionList} = useAppData();
	const callBack = () =>{
		getInventoryStockList();
		getInventoryTransactionList();
	}
  return (
	<ErpLayout>
		<div className='row'>
			
			<div className='col-md-12'> 
				<span className='float-end'><InventoryForm callBack={callBack} /></span>
			</div>
			<div className='col-md-12 mt-2'>
				<InventoryStockList />
			</div>
			
			<div className='col-md-12 mt-2'>
				<InventoryTransactionList />
			</div>
		</div>
	</ErpLayout>    
  	)
}

export default InventoryDashboardPage